import { Embed as EmbedIcon } from 'almanac-ui/icons'
import { InlineFormatButton } from 'components/InlineFormatBar/components/InlineFormatButton/InlineFormatButton'
import { maybeConvertToEmbed } from 'proseShared/plugins/PastePlugin/utils'
import { type EditorView } from 'prosemirror-view'
import type React from 'react'
import * as allRegexMatches from 'screens/ProseEdit/utils'
import { type Node as ProseNode } from 'prosemirror-model'
import { showErrorMessageToast } from 'common/MessageToasts/ErrorMessageToast/ErrorMessageToast'

const ALL_TP_REGEX_MATCHES = Object.values(allRegexMatches).filter((l): l is RegExp => l instanceof RegExp)

export type TurnIntoEmbedButtonProps = {
  view: EditorView
  linkPosition: {
    from: number
    to: number
  }
  node?: ProseNode | null
  currentLink?: string
}

export const TurnIntoEmbedButton: React.FC<React.PropsWithChildren<TurnIntoEmbedButtonProps>> = ({
  node,
  linkPosition,
  view,
  currentLink,
}) => {
  if (node == null || linkPosition == null) {
    return null
  }

  const link = currentLink ?? node.attrs.link ?? node.attrs.url

  const turnIntoEmbed = () => {
    if (!node) {
      return
    }
    const tr = view.state.tr
    tr.delete(linkPosition.from - 1, linkPosition.to + 1)
    const newFrom = tr.mapping.map(linkPosition.from - 1)
    if (maybeConvertToEmbed(view, link, newFrom, tr)) {
      view.dispatch(tr)
    } else {
      showErrorMessageToast('This link could not be converted to an embed')
    }
  }

  return (
    <InlineFormatButton
      isDisabled={!isIntegration(link)}
      onPress={turnIntoEmbed}
      data-testid="turn-into-embed-button"
      label="Turn into embed"
    >
      <EmbedIcon />
    </InlineFormatButton>
  )
}

const isIntegration = (link: string) =>
  ALL_TP_REGEX_MATCHES.some((regex): boolean => {
    return !!regex.exec(link)
  })
